import type { FC } from 'react';
import { useMemo } from 'react';
import { useAppSelector } from '@/Module/Store/Hook';
import { SubscriptionHistoryNoPrevious } from '@/Module/Subscription/Component';
import { selectedSubscriptionV2UserActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionV2UserActiveSelector';
import SubscriptionHistoryPreviousActive from './SubscriptionHistoryPreviousActive';
interface IPropsSubscriptionHistoryPrevious {
  single?: boolean;
}
const SubscriptionHistoryPrevious: FC<IPropsSubscriptionHistoryPrevious> = ({
  single
}) => {
  const listSubscriptionActive = useAppSelector(state => selectedSubscriptionV2UserActiveSelector(state));
  const data = useMemo(() => {
    if (single) {
      return listSubscriptionActive.filter(item => item.subscriptionType === 'فروشگاهی');
    }
    return listSubscriptionActive.filter(item => item.subscriptionType !== 'فروشگاهی');
  }, [listSubscriptionActive]);
  return <div className=" py-4 sm:py-4" data-sentry-component="SubscriptionHistoryPrevious" data-sentry-source-file="SubscriptionHistoryPrevious.tsx">
      {!data.length ? <SubscriptionHistoryNoPrevious /> : <div className="mb-8 grid gap-6     xl:grid-cols-2">
          {data.map(item => <SubscriptionHistoryPreviousActive key={item.subscriptionPlanId} subscriptionActive={item} />)}
        </div>}
    </div>;
};
export default SubscriptionHistoryPrevious;